var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _path7, _path8, _path9, _path0, _path1, _path10, _rect3, _path11, _path12, _path13, _path14, _path15, _path16, _rect4, _path17, _rect5, _path18, _rect6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistenceSmokingCessation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 141,
    viewBox: "0 0 282 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 35,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#D7512D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9229 66.3851C21.9229 65.7053 22.4739 65.1543 23.1536 65.1543H29.9229C30.2627 65.1543 30.5382 65.4298 30.5382 65.7697V71.9235C30.5382 72.2634 30.2627 72.5389 29.9229 72.5389H23.1536C22.4739 72.5389 21.9229 71.9879 21.9229 71.3081V66.3851Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3848 71.9235V65.7697C32.3848 65.4298 32.6603 65.1543 33.0001 65.1543H37.0529C37.2162 65.1543 37.3727 65.2191 37.4881 65.3345L43.6419 71.4884C44.0296 71.8761 43.755 72.5389 43.2068 72.5389H33.0002C32.6603 72.5389 32.3848 72.2634 32.3848 71.9235Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8457 66.3842V71.3073C58.8457 71.9871 58.2947 72.5381 57.6149 72.5381H50.1247C49.7983 72.5381 49.4853 72.4084 49.2544 72.1776L43.2808 66.204C42.8932 65.8163 43.1677 65.1535 43.716 65.1535H57.6149C58.2947 65.1535 58.8457 65.7045 58.8457 66.3842Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.154 52.231L54.7221 53.3826C54.2244 54.7099 54.4379 56.1993 55.2884 57.3333V57.3333C55.987 58.2648 56.2626 59.4467 56.048 60.591L55.7694 62.0771",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6149 51.6158L49.1831 52.7674C48.6854 54.0946 48.8989 55.5841 49.7494 56.7181V56.7181C50.448 57.6495 50.7235 58.8314 50.509 59.9758L50.2303 61.4619",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7695 51.6152L52.0772 79.9229",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 35,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#D7512D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.923 66.3851C117.923 65.7053 118.474 65.1543 119.154 65.1543H125.923C126.263 65.1543 126.538 65.4298 126.538 65.7697V71.9235C126.538 72.2634 126.263 72.5389 125.923 72.5389H119.154C118.474 72.5389 117.923 71.9879 117.923 71.3081V66.3851Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.385 71.9235V65.7697C128.385 65.4298 128.66 65.1543 129 65.1543H133.053C133.216 65.1543 133.373 65.2191 133.488 65.3345L139.642 71.4884C140.03 71.8761 139.755 72.5389 139.207 72.5389H129C128.66 72.5389 128.385 72.2634 128.385 71.9235Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M154.846 66.3842V71.3073C154.846 71.9871 154.295 72.5381 153.615 72.5381H146.125C145.798 72.5381 145.485 72.4084 145.254 72.1776L139.281 66.204C138.893 65.8163 139.168 65.1535 139.716 65.1535H153.615C154.295 65.1535 154.846 65.7045 154.846 66.3842Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M151.154 52.231L150.722 53.3826C150.224 54.7099 150.438 56.1993 151.288 57.3333V57.3333C151.987 58.2648 152.263 59.4467 152.048 60.591L151.769 62.0771",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M145.615 51.6158L145.183 52.7674C144.685 54.0946 144.899 55.5841 145.749 56.7181V56.7181C146.448 57.6495 146.724 58.8314 146.509 59.9758L146.23 61.4619",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119.77 51.6152L148.077 79.9229",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 27,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#D7512D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M209.154 66.2308C209.154 65.3812 209.843 64.6924 210.693 64.6924H219.154C219.579 64.6924 219.924 65.0368 219.924 65.4616V73.1539C219.924 73.5788 219.579 73.9232 219.154 73.9232H210.693C209.843 73.9232 209.154 73.2344 209.154 72.3847V66.2308Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M222.23 73.1539V65.4616C222.23 65.0368 222.575 64.6924 223 64.6924H228.066C228.27 64.6924 228.465 64.7734 228.61 64.9177L236.302 72.61C236.787 73.0946 236.443 73.9232 235.758 73.9232H223C222.575 73.9232 222.23 73.5788 222.23 73.1539Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M255.308 66.2305V72.3844C255.308 73.2341 254.619 73.9229 253.769 73.9229H244.406C243.998 73.9229 243.607 73.7608 243.319 73.4722L235.852 66.0052C235.367 65.5207 235.71 64.6921 236.395 64.6921H253.769C254.619 64.6921 255.308 65.3809 255.308 66.2305Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M250.692 48.538L250.152 49.9775C249.53 51.6366 249.797 53.4984 250.86 54.9159V54.9159C251.733 56.0802 252.078 57.5576 251.81 58.9881L251.461 60.8457",
    stroke: "white",
    strokeWidth: 3.07692,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M243.769 47.7695L243.229 49.2089C242.607 50.868 242.874 52.7298 243.937 54.1473V54.1473C244.81 55.3117 245.155 56.789 244.887 58.2195L244.538 60.0771",
    stroke: "white",
    strokeWidth: 3.07692,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M211.462 47.7695L246.847 83.1541",
    stroke: "white",
    strokeWidth: 3.07692,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 81,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M161.5 97L165.5 101L172.5 93",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 81,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 97L69.5 101L76.5 93",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 81,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 97,
    r: 2,
    fill: "#24284E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 97,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 97,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 139,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 3,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 133.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 27.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 18.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.5,
    cy: 111.5,
    r: 1.5,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.5,
    cy: 121.5,
    r: 1.5,
    fill: "white"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.5,
    cy: 27.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 280.5,
    cy: 25.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M192 3.5L202.5 17.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M261 2L255.5 17",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M215.5 120.5L209.5 134.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceSmokingCessation);
export default __webpack_public_path__ + "static/media/persistence-smoking-cessation.ddd410eca39798bb05094765d1689250.svg";
export { ForwardRef as ReactComponent };